<template>
  <div class="nelson-button">{{ label }}</div>
</template>

<script>
export default {
  name: 'NelsonButton',
  props: [
      'label'
  ]
};
</script>

<style scoped>

.nelson-button {
  cursor: pointer;
  background-color: var(--nelson-green);
  color: white;
  height: 35px;
/*  width: 120px;*/
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 900;
  letter-spacing: 0.05em;
  margin: 20px;
}

</style>